import { render, staticRenderFns } from "./EditPortfolio.vue?vue&type=template&id=d9a272c6&scoped=true&"
import script from "./EditPortfolio.vue?vue&type=script&lang=js&"
export * from "./EditPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a272c6",
  null
  
)

export default component.exports